module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isParticipantSubmission) ? _c('case-managers', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.field.hide && _vm.required
      }),
      expression: "{required: !field.hide && required}"
    }],
    attrs: {
      "name": _vm.field.name,
      "id": _vm.field.name,
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "value": _vm.value,
      "disable": _vm.locked || _vm.userAccessLevel < 2
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }) : _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-555b54be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/CaseManagerRender.vue
// module id = 1643
// module chunks = 1